import React, { Fragment, ReactChild, ReactChildren } from 'react';
import 'semantic-ui-css/semantic.min.css'
import { Switch, Route } from "react-router-dom";
import { NavbarProvider, Footer } from './components';
import { Home, News, Download, /* GameManual, */ Basics } from './views'
import { Container } from 'semantic-ui-react';
import styled from 'styled-components';
import { LegalDisclamer } from './views/LegalDisclamer';

const innerStyle = {
  padding: 25
}

const App = () => {
  return (
    <Switch>
      <Route exact path="/" >
        <Homepage>
          <Base>
            <Home />
          </Base>
        </Homepage>
      </Route>
      <Route exact path="/news" render={() => <Pages><News /></Pages>} />
      <Route exact path="/download" render={() => <Pages><Download /></Pages>} />
      <Route path="/manual" render={(match) => <Pages><Basics {...match} /></Pages>} />
      <Route path="/legal-disclamer" render={() => <Pages><LegalDisclamer /></Pages>} />
       <ExternalLinks />
    </Switch>
  );
}
interface BaseProps {
  children: ReactChild | ReactChildren;
}
const Base = ({ children }: BaseProps) => (
  <NavbarProvider>
    <Fragment>
      <div>
        <Container text >
          <div style={innerStyle}>
            {children}
          </div>
        </Container>
      </div>
      <Footer />
    </Fragment>
  </NavbarProvider>
)

const Homepage = styled.div`
  text-align: center;
  height: auto;
  background-image: url('/assets/back2.png');
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-color: #000000;
`

const Wrapper = styled.div`
  text-align: center;
  height: auto;
  background-color: #000000;
`
const Pages = ({ children }: BaseProps) => (
  <Wrapper>
    <Base>
      {children}
    </Base>
  </Wrapper>
)

const ExternalLinks = () => (
  <Fragment>
    <Route
      path="/patreon"
      component={() => {
        global.window && (global.window.location.href = 'https://www.patreon.com/arenagames');
        return null;
      }}
    />
    <Route
      path="/download/mac"
      component={() => {
        global.window && (global.window.location.href = 'https://download1514.mediafire.com/oibyn7ghlptg/s3b9is12s081ha0/Soul-Arena-Beta-MacOS.zip');
        return null;
      }}
    />
    <Route
      path="/download/windows"
      component={() => {
        global.window && (global.window.location.href = 'https://download1509.mediafire.com/2dmg00k4iemg/2179hcenvoh2gyc/Soul-Arena-Beta-x64.exe');
        return null;
      }}
    />
    <Route
      path="/download/windows-x86"
      component={() => {
        global.window && (global.window.location.href = 'https://download947.mediafire.com/kbgztnvx78rg/gmz2xxe0z3l7wpy/Soul-Arena-Beta.exe');
        return null;
      }}
    />
    <Route
      path="/download/linux-x86"
      component={() => {
        global.window && (global.window.location.href = 'https://download1514.mediafire.com/3r1hwbe20ijg/75plj7ehpyir6vh/Soul-Arena-Beta.x86');
        return null;
      }}
    />
    <Route
      path="/download/linux"
      component={() => {
        global.window && (global.window.location.href = 'https://download1495.mediafire.com/61ude755ihjg/01twe69n8k6w67e/Soul-Arena-Beta-x64.x86_64');
        return null;
      }}
    />
    <Route
      path="/download/android"
      component={() => {
        global.window && (global.window.location.href = 'https://download938.mediafire.com/363guauowamg/o4ig7bv9cpkxfk0/Soul-Arena-Beta.apk');
        return null;
      }}
    />
    <Route
      path="/discord"
      component={() => {
        global.window && (global.window.location.href = 'https://discord.gg/VVCQU7Yh7z');
        return null;
      }}
    />
  </Fragment>
)


export default App;
